module.exports = __webpack_public_path__ + "static/media/humanislets-Figure7-L.c56a9a4e.jpg";